/**
 * useOnlineStatus Hook
 * 
 * Monitors network connectivity and updates rider store
 */

import { useEffect } from 'react';
import { useRiderStore } from '@/store/rider';
import { logger } from '@/lib/logger';

export function useOnlineStatus() {
  const setIsOnline = useRiderStore((state) => state.setIsOnline);
  const isOnline = useRiderStore((state) => state.isOnline);

  useEffect(() => {
    const handleOnline = () => {
      logger.info('Network: Online');
      setIsOnline(true);
    };

    const handleOffline = () => {
      logger.warn('Network: Offline');
      setIsOnline(false);
    };

    // Set initial state
    setIsOnline(navigator.onLine);

    // Listen for changes
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setIsOnline]);

  return isOnline;
}


















